import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ e("path", { d: "M10 6.75A3.25 3.25 0 0 0 6.75 10a.75.75 0 0 1-.75.75 3.25 3.25 0 0 0-1.78 5.97l-1.076 1.076A4.751 4.751 0 0 1 5.3 9.3a4.751 4.751 0 0 1 8.495-2.157L12.72 8.22A3.247 3.247 0 0 0 10 6.75Z" }, null, -1), c = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "m6.31 18.75-1.78 1.78a.75.75 0 0 1-1.06-1.06l14-14a.75.75 0 1 1 1.06 1.06l-1.167 1.168c1.358.684 2.336 2.075 2.415 3.633A3.751 3.751 0 0 1 19 18.75H6.31Zm9.9-9.9c1.285.367 2.242 1.686 2.048 3.044a.75.75 0 0 0 .742.856 2.25 2.25 0 0 1 0 4.5H7.81l8.4-8.4Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  n,
  c
];
function r(s, a) {
  return t(), o("svg", l, [...d]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
